import "./MarketingHeader.css";
import React from "react";
import map from "lodash/map";
import FlyoutTile from "gradifui/components/header/FlyoutTile";
import LabelledItem from "gradifui/components/header/LabelledItem";
import LogoItem from "gradifui/components/header/LogoItem";
import BaseHeader from "gradifui/components/header/BaseHeader";
import RequestDemoButton from "shared/components/marketing/RequestDemoButton";
import { URLS } from "util/constants";

const flyoutTileData = [
    {
        tileName: "Overview",
        tileDescription: "See the whole Gradifi suite of solutions.",
        additionalClass: "product-overview",
        imgAlt: "Gradifi Product Overview",
        imgPath: require("../assets/redesign2020/product-overview-border.png"),
        url: URLS.MARKETING.PRODUCTS
    },
    {
        tileName: "FinancialCore",
        tileDescription: "Empower your employees with tools and resources.",
        additionalClass: "fincore",
        imgAlt: "Financial Core",
        imgPath: require("../assets/redesign2020/fincore-border-logo.png"),
        url: URLS.MARKETING.REFI
    },
    {
        tileName: "Student Loan PayDown",
        tileDescription: "Help employees pay down student loans.",
        additionalClass: "slp",
        imgAlt: "Student Loan PayDown",
        imgPath: require("../assets/redesign2020/slp-border-logo.png"),
        url: URLS.MARKETING.PAYDOWN
    },
    {
        tileName: "College SaveUp",
        tileDescription: "Offer employees solutions to save for their children's education.",
        additionalClass: "csu",
        imgAlt: "College SaveUp",
        imgPath: require("../assets/redesign2020/csu-border-logo.png"),
        url: URLS.MARKETING.SAVEUP
    }
];

export default ({ isLoggedIn, requestInfoUrl, loginPath }) => {

    const mobileMenuRender = () => (
        <div className="marketing-header-mobile">
            <div className="products">
                {/* The checkbox acts as a non-js toggle to show/hide the dropdown list */}
                <input
                    className="product-header-checkbox"
                    type="checkbox"
                    id="marketing-header-mobile-checkbox"
                    aria-label="Product Dropdown Button"
                />
                <label
                    className="product-header"
                    aria-hidden="true"
                    htmlFor="marketing-header-mobile-checkbox"
                >
                        Solutions
                </label>
                <div className="product-dropdown">
                    {map(flyoutTileData, ({ tileName, url, additionalClass }) => (
                        <a key={tileName} className={additionalClass} href={url}>{tileName}</a>
                    ))}
                </div>
            </div>
            <a className="request-demo" href={requestInfoUrl} target="_blank">Request A Demo</a>
            {isLoggedIn ?
                <a className="logout" href={URLS.LOGOUT}>Logout</a> :
                <a className="login" href={loginPath}>Login/Register</a>
            }
        </div>
    );

    return (
        <BaseHeader
            mobileRender={mobileMenuRender()}
            disableMobileTransform={true}
            disableDesktopTransform={false}
        >
            <nav className="left-section">
                <LogoItem url={URLS.HOME} />
            </nav>
            <nav className="right-section">
                <div className="marketing-header-solutions">
                    <LabelledItem label="Solutions" className="solutions-link" icon="icon-down-dir" showChildrenOnHover={true}>
                        <div className="flyout-container">
                            {map(flyoutTileData, props => <FlyoutTile key={props.tileName} {...props} />)}
                        </div>
                    </LabelledItem>
                </div>
                {isLoggedIn &&
                    <LabelledItem label="Log Out" url={URLS.LOGOUT} />
                }
                {!isLoggedIn &&
                    <React.Fragment>
                        <div className="btn-demo-header-mobile btn-demo-header">
                            <RequestDemoButton url={requestInfoUrl} />
                        </div>
                        <div className="login-link-section">
                            <div className="login-link-content login-link-wrapper">
                                <LabelledItem label="Login/Register" url={loginPath} className="login-link" />
                            </div>
                            <div className="login-link-content right-arrow-wrapper">
                                <a href={loginPath}>
                                    <img className="right-arrow" src={require("../assets/redesign/right_arrow.svg")} alt="" />
                                </a>
                            </div>
                        </div>
                    </React.Fragment>
                }
            </nav>
        </BaseHeader>
    );
};
